import { cn } from '@/utils/tailwind';

export const TitleText = ({ title, className = '' }: { title: string; className?: string }) => {
  return <h1 className={cn('text-gr-900 Title2S24', className)}>{title}</h1>;
};
